// extracted by mini-css-extract-plugin
export var actionText = "_ph-4";
export var container = "_ph-0";
export var leftSection = "_ph-1";
export var rightSection = "_ph-2";
export var settingsButton = "_ph-6";
export var settingsIcon = "_ph-7";
export var shortcut = "_ph-5";
export var shortcutGroup = "_ph-3";